import AbmInfoPortal from "../../components/textos/AbmInfoPortal/AbmInfoPortal";

export const configTable = {
    urls: [
        "/Texto/GetByIdTipoTexto/14?Pagina=1&RegistrosPorPagina=-1", // GET
        "/Texto", // POST 
        "/Texto", // PUT
        "/Texto" // DELETE
    ],
    grid: {
        columnConfig: ["id","nombre", "descripcion"], 
        searchField: ["nombre", "id", "descripcion"]
    },
    Abm: AbmInfoPortal,
    textSize: 10
}